const siteSettingsInitialState = {
  data: {},
};

export default siteSettingsInitialState;